module.exports = __webpack_public_path__ + "static/media/gemo.652a94a6.svg";